import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { AuthProvider } from './context/AuthContext';
import { PageStatusGuard } from './components/layout/PageStatusGuard';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AuthProvider>
        <Suspense
          fallback={
            <div className="flex items-center justify-center min-h-screen">
              <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-[#5A2FCF]"></div>
            </div>
          }
        >
          <PageStatusGuard>
            <AppRoutes />
          </PageStatusGuard>
        </Suspense>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;